import { z } from 'zod';
import { randomNumber } from '../utils';

export const legalClientAddressSchema = z.object({
  idAddress: z.number(),
  idPostcode: z.number(),
  Postcode: z.string().min(1),
  FederalState: z.string().optional(),
  idFederalState: z.number().optional(),
  idCountry: z.number().nullable(),
  Country: z.string().min(1),
  City: z.string().min(1),
  idCity: z.number(),
  Street: z.string().nullable().optional(),
  Number: z.string().nullable().optional(),
  StreetAdditional: z.string().nullable(),
  idLegalClientAddress: z.number(),
  idAddresstype: z.number(),
  LegalTransactionArray: z.array(z.number()),
});

export type ILegalClientAddress = z.infer<typeof legalClientAddressSchema>;

export const initAddress = (): ILegalClientAddress => ({
  idAddress: randomNumber() * -1,
  idPostcode: -1,
  idFederalState: -1,
  idCountry: 1,
  idCity: -1,
  idLegalClientAddress: -1,
  idAddresstype: 1,
  Postcode: '',
  FederalState: '',
  Country: '',
  City: '',
  Street: '',
  Number: '',
  StreetAdditional: null,
  LegalTransactionArray: [],
});
